import { useState } from 'react';
import { Shovel, Pencil, LocateFixed, Calculator } from 'lucide-react';
import { computePit, pitRing, f2 } from '../lib/excavation';
import { eur } from '../lib/license';
import PitCostDialog from './PitCostDialog';

export default function PitList({ t, project, pits, onLocate }) {
  const [cost, setCost] = useState(false);
  if (!pits?.pits.length) return null;
  const rows = pits.pits.map((p) => ({ p, c: computePit(p) }));
  const sum = rows.reduce((s, { c }) => ({ m3: s.m3 + c.excav.m3, cost: s.cost + c.total }), { m3: 0, cost: 0 });
  return (
    <div className="pit-list" data-testid="pit-list">
      <div className="sub-title"><Shovel size={14} /> {t.pitCount} <em className="count" data-testid="pit-count">{rows.length}</em></div>
      {rows.map(({ p, c }, i) => (
        <div key={p.id} className="pipe-card pit-card" data-testid={`pit-card-${i}`}>
          <span className="pipe-swatch pit-swatch" />
          <b className="pit-card-name">{p.name}</b>
          <span className="pit-card-kpi" data-testid={`pit-card-kpi-${i}`}>{f2(c.area, t.locale)} m² · {f2(c.excav.m3, t.locale)} m³{c.priced ? ` · ${eur(c.total, t.locale)}` : ''}</span>
          <button className="btn btn-outline btn-sm" data-testid={`pit-locate-btn-${i}`} onClick={() => onLocate(pitRing(p))}><LocateFixed size={14} /></button>
          <button className="btn btn-dark btn-sm" data-testid={`pit-edit-btn-${i}`} onClick={() => pits.open(p.id)}><Pencil size={14} /></button>
        </div>
      ))}
      <div className="pipe-total" data-testid="pit-total">{t.pitSum}: {f2(sum.m3, t.locale)} m³ · {eur(sum.cost, t.locale)}</div>
      <button className="btn btn-proj btn-sm" data-testid="pit-cost-btn" onClick={() => setCost(true)}><Calculator size={14} /> {t.pitCostTitle}</button>
      {cost && <PitCostDialog t={t} project={project} pits={pits.pits} onClose={() => setCost(false)} />}
    </div>
  );
}
